<template>
  <div id="page-loading">
    <transition name="fadeOut">
      <div class="page-loading-inner" v-if="$store.getters.loading.page">
        <div class="image-loader">
          <div class="loader">
          </div>
          <img src="../../assets/images/icons/mall-loading-whatermark.svg" alt="Tbilisi Mall">
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'page-loading'
}
</script>
<style lang="scss">
#page-loading{
  .page-loading-inner{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background-color: #fff;
    &.fadeOut-enter-active {
      animation: fadeIn .4s;
    }
    &.fadeOut-leave-active {
      animation: fadeOut .5s;
    }
    .image-loader{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      img{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 79%;
        transform: translate(-50%, -50%);
      }
      .loader {
        font-size: 10px;
        margin: 50px auto;
        text-indent: -9999em;
        width: 75px;
        height: 75px;
        border-radius: 50%;
        background: #000000;
        background: -moz-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
        background: -webkit-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
        background: -o-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
        background: -ms-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
        background: linear-gradient(to right, #000000 10%, rgba(255, 255, 255, 0) 42%);
        position: relative;
        -webkit-animation: load3 1.4s infinite linear;
        animation: load3 1.4s infinite linear;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
      }
      .loader:before {
        width: 50%;
        height: 50%;
        background: #000000;
        border-radius: 100% 0 0 0;
        position: absolute;
        top: 0;
        left: 0;
        content: '';
      }
      .loader:after {
        background: #ffffff;
        width: 85%;
        height: 85%;
        border-radius: 50%;
        content: '';
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
      }
    }
  }
  @-webkit-keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}
</style>
